import { render } from "./BookingCabin.vue?vue&type=template&id=dcb18f3a&scoped=true"
import script from "./BookingCabin.vue?vue&type=script&lang=js"
export * from "./BookingCabin.vue?vue&type=script&lang=js"

import "./BookingCabin.vue?vue&type=style&index=0&id=dcb18f3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcb18f3a"]])

export default __exports__